exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".app-body{margin:0 auto;max-width:1160px;min-width:920px;padding:0 20px;background:#f1f1f1;padding-top:137px}.app-body.full-width{max-width:100%}@media print{.app-body{padding-top:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/index.scss
// module id = 5081
// module chunks = 0